<template>
  <div>
    <div class="row">
    <div class="col">
      <div class="form-group">
        <table class="table table-striped table-hover table-bordered">
          <thead class="thead-dark">
            <tr>
              <th>Variedad</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tableVariety in listComposition" :key="tableVariety.id">
              <td>{{tableVariety.variety}}</td>
              <td>{{tableVariety.percent}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Get } from "../../../../helper/axios.js";
export default {
  data() {
    return {
      apiUrl: this.$store.getters.apiUrl,
      Get,
      tableVarieties: []
    };
  },
  props: ["listComposition"],
  created() {
    //this.getComposition();
  },
  methods: {
  }
};
</script>


